import React, { Component } from 'react';
import style from './DefaultBtn.module.css';
// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class SearchBtn extends Component {
    render() {
        return (
            <div className={style.area}>
                {/* <div className={style.btn} onClick={this.props.onClick} name={this.props.name} >{this.props.label}  </div> */}

                {this.props.type === "primary" &&
                    <button type="button" className={style.btnPrimary} onClick={this.props.onClick} name={this.props.name} >{this.props.label}  </button>
                }
                {this.props.type === "default" &&
                    <button type="button" className={style.btnDefault} onClick={this.props.onClick} name={this.props.name} >{this.props.label}  </button>
                }
                {this.props.type === "danger" &&
                    <button type="button" className={style.btnDanger} onClick={this.props.onClick} name={this.props.name} >{this.props.label}  </button>
                }
                {this.props.type === "info" &&
                    <button type="button" className={style.btnInfo} onClick={this.props.onClick} name={this.props.name} >{this.props.label}  </button>
                }




            </div>
            
        );
    }
}
export default SearchBtn